import React from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SectionContainer from './SectionContainer';
import SectionEyebrow from './SectionEyebrow';
import { faqs } from './content';

const FAQSection = () => (
  <SectionContainer id="faq" sx={{ py: { xs: 6, md: 10 } }}>
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 4, md: 8 }, alignItems: 'flex-start' }}>
      <Box sx={{ flex: 1, width: '100%' }}>
        <SectionEyebrow color="#2563EB">Frequently Asked Questions</SectionEyebrow>
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 4, fontSize: { xs: 24, md: 32 } }}>
          Everything you need to know
        </Typography>

        {faqs.map(({ question, answer }) => (
          <Accordion
            key={question}
            disableGutters
            elevation={0}
            sx={(theme) => ({
              bgcolor: 'transparent',
              borderBottom: '1px solid',
              borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.08)',
              '&:before': { display: 'none' },
            })}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 600, fontSize: 15 }}>{question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{ color: 'text.secondary', fontSize: 14 }}>{answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      <Box
        sx={{
          flex: '0 0 auto',
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
          width: 280,
          height: 280,
        }}
      >
        <Box
          component="img"
          src="/FAQs.png"
          alt="Frequently asked questions"
          sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      </Box>
    </Box>
  </SectionContainer>
);

export default FAQSection;
